import React, { useEffect, useState, useRef } from "react";
import useHttp from "../../../../hooks/use-http";
import Pagination from "../../../../components/Pagination";

import { Modal as AntModal, Spin } from "antd";
import Modal from "react-modal";
import { toast } from "react-toastify";
import html2pdf from "html2pdf.js";

const WorkServiceInvoiceList = (props) => {
  const [loading, setLoading] = useState({
    approve: false,
    disapprove: false,
    sendNextApprove: false,
  });

  const [deleteLoading, setDeleteLoading] = useState(false);

  const { addForm, update, sId } = props;
  const [data, setData] = useState([]);
  const [itemsPerPage] = useState(10);
  const { sendRequest: getUser } = useHttp();

  const { sendRequest: getDataList } = useHttp();
  const [allData, setAllData] = useState([]);
  const [wsiId, setWsiId] = useState();
  const [docurl, setDocUrl] = useState(false);

  const { sendRequest: deleteInvoice } = useHttp();

  const deleteOperation = (e, data) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete these detail?",
      onOk() {
        setDeleteLoading(data);
        const input = {
          
          wsiId:data.wsiId,
          serviceId: serviceId,
          createdBy:loginUserId,
          orgId:data.orgId,
          status: 0,
        };

        deleteInvoice(
          {
            url: "/api/workServiceInvoice/",
            method: "delete",
            body: input,
          },
          (data) => {
            toast.success("Data deleted successfully");
            FillDetail();
            setDeleteLoading(false);
          },
          () => {
            setDeleteLoading(false);
          }
        );
      },
      onCancel() {
        setDeleteLoading(false);
      },
    });
  };

  const FillDetail = () => {
    getDataList(
      {
        url: `/api/workServiceInvoice/?orgId=${localStorage.getItem(
          "orgId"
        )}&warehouseId=${localStorage.getItem("warehouseId")}`,
      },
      (res) => {
        if (res) {
          setData(res);
          setAllData(res);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getDataList]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();
    //console.log(filetrtext);

    var filterdata = allData.filter(
      (item) =>
        item?.goodsTrasnferNo?.includes(filetrtext) ||
        item?.employeeName?.includes(filetrtext) ||
        item?.vmeNo?.includes(filetrtext) ||
        item?.driverName?.includes(filetrtext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
      left: 30,
    },
    content: {
      top: "50%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "800px",
      minHeight: "500px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      //border: "5px solid #96dc00",
    },
  };
  const { sendRequest: getDetailView } = useHttp();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    // //console.log(data);

    const Id = data && data.wsiId;

    getDetailView(
      {
        url: `/api/workServiceInvoice/?orgId=${localStorage.getItem(
          "orgId"
        )}&wsiId=${Id}`,
      },
      (res) => {
        console.log("Detail View", res);
        setSelectedData(res);
      }
    );

    //  setSelectedData(data);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const [loginUserId, setLoginUserId] = useState(localStorage.getItem("id"));
  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        console.log(itemselected);

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);

  const [selectedWorkInvoice, setSelectedWorkInvoice] = useState(null);
  const [approvalPopupVisible, setApprovalPopupVisible] = useState(false);

  const [remark, setRemark] = useState("");

  const { sendRequest: updateApprovalStatus } = useHttp();

  const showApprovalPopup = (expense) => {
    console.log(expense);
    setSelectedWorkInvoice(expense);
    setApprovalPopupVisible(true);
  };

  const handleRemarkChange = (e) => {
    setRemark(e.target.value);
  };

  const handleApprovalSubmit = (status) => {
    const approvalStatus = status || "";

    setLoading((prevState) => ({ ...prevState, [status]: true }));
    let data = "";
    const getApprovalData = (approvalStatus) => {
      const baseData = {
        itemId: selectedWorkInvoice && selectedWorkInvoice.wsiId,
        approvedBy: parseInt(localStorage.getItem("empId")),
        serviceId: serviceId,
        nextlevel: 0,
        orgId: localStorage.getItem("orgId"),
        remark: remark,
      };

      switch (approvalStatus) {
        case "approve":
          return { ...baseData, approved: 1 };
        case "disapprove":
          return { ...baseData, approved: 2 };
        case "sendNextApprove":
          return { ...baseData, approved: 0, nextlevel: 1 };
        default:
          return baseData;
      }
    };

    data = getApprovalData(approvalStatus);

    updateApprovalStatus(
      {
        url: "/api/approveworkServiceinvoice/",
        method: "PUT",
        body: data,
      },
      (data) => {
        toast.success(data);

        setApprovalPopupVisible(false);
        setRemark("");
        FillDetail();
        setLoading({
          approve: false,
          disapprove: false,
          sendNextApprove: false,
        });
      },
      () => {
        setLoading({
          approve: false,
          disapprove: false,
          sendNextApprove: false,
        });
      }
    );
  };

  const pdfContainerRef = useRef(null);
  const [pdfView, setPdfView] = useState(false);
  const [pdfData, setPdfData] = useState([]);

  const viewPdf = (id) => {
    setPdfView(true);

    if (id) {
      getDetailView(
        {
          url: `/api/workServiceInvoice/?orgId=${localStorage.getItem(
            "orgId"
          )}&wsiId=${id}`,
        },
        (res) => {
          if (res) {
            setPdfData(res);
            console.log(res);
          }
        }
      );
    }
  };

  const printPdfContainer = () => {
    const elementsToHide = document.querySelectorAll(".no-print");
    elementsToHide.forEach((element) => {
      element.style.display = "none !important";
    });
    document.body.style.overflow = "visible";

    window.print();
    document.body.style.overflow = "";
    elementsToHide.forEach((element) => {
      element.style.display = "";
    });
  };

  const generatePDF = (docNo) => {
    const input = pdfContainerRef.current;

    const pdfName = docNo || "Work Service Invoice";

    html2pdf(input, {
      margin: 10,
      filename: `${pdfName}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "pt", format: "a4", orientation: "portrait" },
      pagebreak: { mode: "avoid-all" },
    });
  };

  const dealType = (option) => {
    switch (option) {
      case 1:
        return "Hourly";
      case 2:
        return "Fix set of hours";
      case 3:
        return "Work Based";
      case 4:
        return "Number of Days";
      case 5:
        return "Other";
    }
  };

  return (
    <>
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        <h4 className="card-title">Work Service Invoice Details</h4>
        <div className="card-tools text-right">
          <button
            type="button"
            className="btn btn-tool"
            data-card-widget="remove"
            onClick={() => setIsModalOpen(false)}
          >
            <i className="fas fa-times" />
          </button>
          <hr />
        </div>
        {selectedData && (
          <div>
            <div className="row">
              <div className="col-md-2">
                {" "}
                <label> Date</label>
              </div>
              <div className="col-md-1">
                <label> : </label>{" "}
              </div>
              <div className="col-md-3">
                {" "}
                <label> {selectedData.goodsTransferDate} </label>{" "}
              </div>
              <div className="col-md-2">
                <label> Field Officer </label>{" "}
              </div>
              <div className="col-md-1">
                {" "}
                <label> : </label>
              </div>
              <div className="col-md-3">
                {" "}
                <label> {selectedData.employeeName} </label>{" "}
              </div>
            </div>

            <div className="row">
              <div className="col-md-2">
                {" "}
                <label> Doc No </label>
              </div>
              <div className="col-md-1">
                <label> : </label>{" "}
              </div>
              <div className="col-md-3">
                {" "}
                <label> {selectedData.goodsTrasnferNo} </label>{" "}
              </div>
              <div className="col-md-2">
                <label> TimeStamp</label>{" "}
              </div>
              <div className="col-md-1">
                {" "}
                <label> : </label>
              </div>
              <div className="col-md-3">
                {" "}
                <label> {selectedData.timeStamp} </label>{" "}
              </div>
            </div>

            <div className="row">
              <div className="col-md-2">
                {" "}
                <label> Warehouse </label>
              </div>
              <div className="col-md-1">
                <label> : </label>{" "}
              </div>
              <div className="col-md-3">
                {" "}
                <label> {selectedData.fromWarehouseName} </label>{" "}
              </div>
              <div className="col-md-2">
                <label> Vehicle</label>{" "}
              </div>
              <div className="col-md-1">
                {" "}
                <label> : </label>
              </div>
              <div className="col-md-3">
                {" "}
                <label> {selectedData.vmeModelName} </label>{" "}
              </div>
            </div>

            <div className="row">
              <div className="col-md-2">
                {" "}
                <label> Driver Name </label>
              </div>
              <div className="col-md-1">
                <label> : </label>{" "}
              </div>
              <div className="col-md-3">
                {" "}
                <label> {selectedData.driverName} </label>{" "}
              </div>
              <div className="col-md-2">
                <label> Driver Contact No </label>{" "}
              </div>
              <div className="col-md-1">
                {" "}
                <label> : </label>
              </div>
              <div className="col-md-3">
                {" "}
                <label> {selectedData.driverContactNo} </label>{" "}
              </div>
            </div>

            <div className="row">
              <div className="col-md-2">
                {" "}
                <label> Start Meter Reading </label>
              </div>
              <div className="col-md-1">
                <label> : </label>{" "}
              </div>
              <div className="col-md-3">
                {" "}
                <label> {selectedData.startMeterReading} </label>{" "}
              </div>
              <div className="col-md-2">
                <label> Remark/Note </label>{" "}
              </div>
              <div className="col-md-1">
                {" "}
                <label> : </label>
              </div>
              <div className="col-md-3">
                {" "}
                <label> {selectedData.remark} </label>{" "}
              </div>
            </div>
            <div className="row">
              <table className="table table-bordered text-center">
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Product Type</th>
                    <th>Product Subtype</th>
                    <th>Product Name</th>
                    <th>Quantity</th>
                    <th>Unit</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedData.productData &&
                    selectedData.productData.map((itm, i) => {
                      return (
                        <tr key={i} className="cursor-pointer">
                          <td>{i + 1}</td>
                          <td>{itm.productTypeName}</td>
                          <td>{itm.productSubTypeName}</td>
                          <td>{itm.productName}</td>
                          <td>{itm.itemQuantity}</td>
                          <td>{itm.unitAbbreviation}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </Modal>

      <div className="content-wrapper">
        <div className="row mx-1">
          <div className="col-6">
            <label className="card-title mx-3 my-3">
              Work Service Invoice Details
            </label>
          </div>

          <div className="col-6 text-right">
            <button
              type="button"
              className="btn  btn-primary mx-3 my-3"
              onClick={() => {
                addForm(true);
                sId(serviceId);
                props.update(false);
              }}
            >
              Add Work Service Invoice
            </button>
          </div>
        </div>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-9"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                          placeholder="Search..."
                        />{" "}
                      </div>
                    </div>
                    <br />
                    <div className="row">
                      <table className="table table-bordered table-responsive text-center">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Assigned Employee </th>
                            <th>Work Service Invoice </th>
                            <th>Work Service Order</th>
                            <th>Vendor Name</th>
                            <th>Amount</th>
                            <th>Currency</th>
                            <th>Approval</th>

                            {canEdit === "block" && <th>Edit</th>}
                            {canDelete === "block" && <th>Delete</th>}
                            {/* {canView === "block" && <th>View</th>} */}
                            {canPdf === "block" && <th>View</th>}
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{x.wsiDate}</td>

                                <td>{x.employeeName}</td>
                                <td>{x.wsiDocNo}</td>
                                <td>{x.wsoDocNo}</td>
                                <td>{x.vendorName}</td>
                                <td>{x.totalWorkOrderAmount}</td>
                                <td>{x.currencyCode}</td>

                                <td>
                                  <button
                                    className="btn"
                                    type="button"
                                    onClick={() => showApprovalPopup(x)}
                                    disabled={
                                      x.nextlevel == 1
                                        ? x.allowApproveUserId == loginUserId
                                          ? false
                                          : true
                                        : x.approved == 0 &&
                                          x.reportingId == loginUserId
                                        ? false
                                        : true
                                    }
                                  >
                                    {x.approved == 1 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "green" }}
                                      ></i>
                                    ) : x.approved == 2 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "red" }}
                                      ></i>
                                    ) : (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "gray" }}
                                      ></i>
                                    )}
                                  </button>
                                </td>
                                {canEdit === "block" && (
                                  <td>
                                    <button
                                      className="btn"
                                      onClick={() => {
                                        props.update(x);
                                        props.sId(serviceId);
                                        props.addForm(true);
                                      }}
                                    >
                                      {" "}
                                      <i className="fas fa-edit"></i>
                                    </button>
                                  </td>
                                )}
                                {canDelete === "block" && (
                                  <td>
                                    {deleteLoading === x ? (
                                      <Spin />
                                    ) : (
                                      <button
                                        onClick={(e) => deleteOperation(e, x)}
                                        className="btn"
                                      >
                                        <i className="fa fa-trash"></i>
                                      </button>
                                    )}
                                  </td>
                                )}
                                {/* {canView === "block" && (
                                  <td>
                                    <button
                                      className="btn"
                                      onClick={() => openModal(x)}
                                    >
                                      <i className="fas fa-eye"></i>
                                    </button>
                                  </td>
                                )} */}
                                {canPdf === "block" && (
                                  <td>
                                    <button
                                      className="btn"
                                      onClick={() => viewPdf(x.wsiId)}
                                    >
                                      {/* <i className="fas fa-solid fa-file"></i> */}
                                      <i className="fas fa-eye"></i>
                                    </button>
                                  </td>
                                )}
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <AntModal
        title="Work Service Invoice Approval"
        open={approvalPopupVisible}
        onCancel={() => setApprovalPopupVisible(false)}
        footer={null}
      >
        <label>Remarks:</label>
        <textarea
          rows={3}
          value={remark}
          className="form-control"
          onChange={handleRemarkChange}
        />
        <br />
        <div>
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => handleApprovalSubmit("approve")}
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.approve ? "Approving..." : "Approve"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            onClick={() => handleApprovalSubmit("disapprove")}
            className="btn btn-sm btn-primary"
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.disapprove ? "Disapproving..." : "Disapprove"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => handleApprovalSubmit("sendNextApprove")}
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.sendNextApprove ? "Sending..." : "Send Next Approve"}
          </button>
        </div>
      </AntModal>
      {pdfView && (
        <Modal isOpen={true} style={customModalStyles}>
          <div className="pdf-main-container ">
            <div className="row no-print">
              <div className="col-md-11"></div>
              <div className="col-md-1">
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => setPdfView(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                </div>
              </div>
            </div>

            <div className="pdf-container mx-3 my-4" ref={pdfContainerRef}>
              <section className="content">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-12">
                      {/* Main content */}
                      <div className="invoice p-3 mb-3">
                        {/* title row */}
                        <div className="row">
                          <div className="col-12">
                            <h4>
                              <img
                                src={`${process.env.REACT_APP_FILE_URL}${
                                  pdfData && pdfData.organizationIcon
                                }`}
                                width="50"
                                height="50"
                                alt=""
                              />
                              &nbsp;Work Service Invoice
                            </h4>
                          </div>
                          {/* /.col */}
                        </div>
                        {/* info row */}
                        <div className="row invoice-info">
                          <div className="col-sm-4 invoice-col">
                            From
                            <address>
                              <strong>{pdfData && pdfData.orgName}</strong>
                              <br />
                              {pdfData && pdfData.orgCity}{" "}
                              {pdfData && pdfData.orgState}
                              <br />
                              {pdfData && pdfData.orgCountry}{" "}
                              {pdfData && pdfData.orgzipCode}
                              <br />
                              Phone: {pdfData && pdfData.orgPhoneNumber}
                              <br />
                              Email: {pdfData && pdfData.orgEmail}
                            </address>
                          </div>
                          {/* /.col */}
                          <div className="col-sm-4 invoice-col">
                            To
                            <address>
                              <strong>{pdfData && pdfData.vendorName}</strong>
                              <br />
                              <p>
                                {pdfData && pdfData.vendorCity}{" "}
                                {pdfData && pdfData.vendorState}
                                <br />
                                {pdfData && pdfData.vendorCountry}{" "}
                                {pdfData && pdfData.vendorzipCode}
                                <br />
                                Phone: {pdfData && pdfData.vendorcontactWork}
                                <br />
                                Email: {pdfData && pdfData.vendoremail}
                              </p>
                            </address>
                          </div>
                          {/* /.col */}
                          <div className="col-sm-4 invoice-col">
                            <br />
                            <b>Invoice Date:</b> {pdfData && pdfData.wsiDate}
                            <br />
                            <b>Invoice No:</b> {pdfData && pdfData.wsiDocNo}
                            <br />
                            <b>Order No:</b> {pdfData && pdfData.wsoDocNo}
                            <br />
                            <b>Currency:</b> {pdfData && pdfData.currencyName}
                            <br />
                          </div>
                          {/* /.col */}
                        </div>
                        {/* /.row */}
                        {/* Table row */}
                        <div className="row">
                          <div className="col-12 table-responsive">
                            <table className="table  table-bordered">
                              <thead style={{ background: "#F0E9EA" }}>
                                <tr>
                                  <th>Sr.No</th>
                                  <th>Labour Count</th>
                                  <th>Service Deal Type</th>
                                  <th>Labour Cost</th>
                                  <th>Labour Trasport Cost</th>
                                  <th>Labour Meal Cost </th>
                                  <th>Currency</th>
                                  <th>Amount</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>{1}</td>

                                  <td>{pdfData && pdfData.labourCount}</td>
                                  <td>
                                    {" "}
                                    {dealType(
                                      pdfData && pdfData.serviceDealType
                                    )}
                                  </td>
                                  <td>{pdfData && pdfData.labourCost}</td>
                                  <td>
                                    {pdfData && pdfData.labourTransportCost}
                                  </td>
                                  <td>{pdfData && pdfData.labourMealCost}</td>
                                  <td>{pdfData && pdfData.currencyName}</td>
                                  <td>{pdfData && pdfData.lineTotalAmount}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          {/* /.col */}
                        </div>
                        {/* /.row */}
                        <div className="row">
                          <div className="col-6">
                            <p className="text-muted well well-sm shadow-none">
                              Remark/Note:
                            </p>
                            <p> {pdfData && pdfData.remark}</p>
                            <hr />
                            <p
                              className="text-muted well well-sm shadow-none"
                              style={{ marginTop: 10 }}
                            >
                              Name of Authorized Signatory:
                            </p>
                            <hr />
                            <p
                              className="text-muted well well-sm shadow-none"
                              style={{ marginTop: 10 }}
                            >
                              Amount Chargeable:{" "}
                            </p>
                            <p> {pdfData && pdfData.amountChargeable}</p>
                            <hr />
                            <p
                              className="text-muted well well-sm shadow-none"
                              style={{ marginTop: 10 }}
                            >
                              This is Computer Generated Document
                            </p>
                          </div>

                          <div className="col-6">
                            <div className="table-responsive">
                              <table className="table">
                                <tbody className="text-right">
                                  <tr>
                                    <th style={{ width: "50%" }}> Subtotal:</th>
                                    <td>
                                      {" "}
                                      {pdfData && pdfData.lineTotalAmount}
                                    </td>
                                  </tr>

                                  <tr>
                                    <th style={{ width: "50%" }}>
                                      Discount:(
                                      {pdfData && pdfData.discountPercentage}%)
                                    </th>
                                    <td>
                                      {" "}
                                      {pdfData && pdfData.discountAmount}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th style={{ width: "50%" }}>
                                      Total Amount:
                                    </th>
                                    <td> {pdfData && pdfData.totalAmount}</td>
                                  </tr>
                                  <tr>
                                    <th>
                                      Tax Amount (
                                      {pdfData && pdfData.taxPercentage}%)
                                    </th>
                                    <td> {pdfData && pdfData.taxAmount}</td>
                                  </tr>

                                  <tr>
                                    <th>Total Cost:</th>
                                    <td>
                                      {" "}
                                      {pdfData && pdfData.totalWorkOrderAmount}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
          <div className="row no-print">
            <div className="col-12">
              {/* <button
      type="button"
      className="btn btn-default print-button"
      onClick={() => printPdfContainer()}
    >
      <i className="fas fa-print" /> Print
    </button> */}

              <button
                type="button"
                className="btn btn-primary float-right generate-pdf-button"
                style={{ marginRight: 5 }}
                onClick={() => generatePDF(pdfData && pdfData.wsiDocNo)}
              >
                <i className="fas fa-download" /> Generate PDF
              </button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default WorkServiceInvoiceList;
